import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { Desktop, Mobile } from '../../App';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import { BACKOFFICE_NAME } from '../../helpers/helperFunctions';
import {
  AKASHA,
  DEX_NET,
  KRIPTO_TAP,
  KYC_START,
  SETTINGS_SECURITY,
  SETTINGS_VIRTUAL_OFFICE
} from '../../routes/routes';
import { color } from '../../styles/GlobalStyles';
import { getDashboardInfo, updateWillyCoins } from './Dashboard.actions';
import { DashboardNotification } from './DashboardNotification';

import { WelcomeSidebar } from './WelcomeSidebar';

import akasha from '../../assets/images/backoffice/akasha/akashaBanner.png';
import akashaMobile from '../../assets/images/backoffice/akasha/akashaBannerMobile.png';

import akashaNotRestricted from '../../assets/images/backoffice/akasha/akashaNotRestrictedBanner.png';
import akashaNotRestrictedMobile from '../../assets/images/backoffice/akasha/akashaNotRestrictedBannerMobile.png';

import {
  Box,
  Flexed,
  ProfileImage,
  ProfilePicture,
  SectionSeparator,
  UserImageCircle
} from '../../styles/GlobalComponents';
import { EarningsComponent2 } from './EarningsComponent2';

import guardianNodesBanner from '../../assets/images/backoffice/guardianNodes/guardianNodesBanner.png';
import guardianNodesBannerMobile from '../../assets/images/backoffice/guardianNodes/guardianNodesBannerMobile.png';

import dreamTripsBanner from '../../assets/images/backoffice/dreamTrips/dreamTripsBanner.png';
import dreamTripsBannerMobile from '../../assets/images/backoffice/dreamTrips/dreamTripsBannerMobile.png';

import bitcoinBanner from '../../assets/images/backoffice/bitcoinBanners/bitcoinBanner.png';
import bitcoinBannerMobile from '../../assets/images/backoffice/bitcoinBanners/bitcoinBannerMobile.png';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

// import required modules
import styled from 'styled-components';
import { Navigation } from 'swiper/modules';
import { SlideWrapper } from './DashboardStyled';

import unitedOneBanner from '../../assets/images/backoffice/unitedOne/unitedOneBanner.png';
import newStrategiesBanner from '../../assets/images/backoffice/unitedOne/newStrategiesBanner.png';
import mex from '../../assets/images/backoffice/unitedOne/mex.png';
import { H3, H4, H5, P2, P3 } from '../../styles/FontStyles';
import { User } from '../../types/loginTypes';

const Dashboard = () => {
  const dispatch = useAppDispatch();
  // const { t } = useTranslation('dashboard');
  const { user } = useAppSelector((state) => state.auth.userInfo);

  const { dashboardInfo, willyCoins, loading } = useAppSelector(
    (state) => state.dashboard
  );

  const history = useHistory();

  useEffect(() => {
    dispatch(getDashboardInfo());
  }, [dispatch]);

  // useEffect(() => {
  //   if (!loading) {
  //     const interval = setInterval(() => {
  //       dispatch(updateWillyCoins(willyCoins));
  //     }, willyCoins.changePeriodInSeconds * 1000);

  //     return () => clearInterval(interval);
  //   }
  // }, [willyCoins]);

  // const KycPackageNotifications = () => {
  //   if (!kycStatus?.isKycCompleted && !kycStatus?.isKycVerified) {
  //     return (
  //       <DashboardNotification
  //         pill={t('kyc_pill')}
  //         title={t('kyc_title')}
  //         text={t('kyc_text')}
  //         buttonOnClick={() => history.push(KYC_START)}
  //         buttonText={t('verify_now')}
  //       />
  //     );
  //   } else return null;
  // };

  // const StartYourJourneyNotification = () => {
  //   if (!dashboardInfo?.user?.currentVirtualOfficeLicence) {
  //     return (
  //       <DashboardNotification
  //         pill={'take the first step today'}
  //         title={'Start your Journey HERE!'}
  //         text={`To achieve the fastest growth, start with the MaVie ${BACKOFFICE_NAME} Subscription.`}
  //         buttonText={`Start with a ${BACKOFFICE_NAME}`}
  //         buttonOnClick={() => history.push(SETTINGS_VIRTUAL_OFFICE)}
  //       />
  //     );
  //   } else return null;
  // };

  // const SecurityNotification = () => {
  //   if (!dashboardInfo?.user?.settings?.signInEmailCodeVerificationEnabled) {
  //     return (
  //       <DashboardNotification
  //         titleColor={color.colors.error500}
  //         pill={t('notifications.security.pill')}
  //         title={t('notifications.security.title')}
  //         text={t('notifications.security.text')}
  //         buttonText={t('notifications.security.button')}
  //         buttonOnClick={() => history.push(SETTINGS_SECURITY)}
  //       />
  //     );
  //   } else return null;
  // };

  if (loading && !dashboardInfo) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'dashboardInfo'}>
      <Flexed gap='20px' rowSM>
        <Flexed width='30%' widthSM='100%'>
          <div style={{ width: '100%' }}>
            <EarningsComponent2 user={user} backOffice={dashboardInfo} />
          </div>
        </Flexed>
        <Flexed column width='70%' widthSM='100%'>
          {/* {canBuyFlipMePackages && ( */}
          {/* <Link to={FLIPME_CARDS}> */}

          <SlideWrapper>
            <Desktop>
              <Flexed mb='20'>
                <img
                  src={unitedOneBanner}
                  alt='flipMeBanner'
                  onClick={() => history.push(AKASHA)}
                />
              </Flexed>
            </Desktop>
            <Flexed gap='20px' rowSM>
              <Box width='50%'>
                <H3 mb='15' color={color.colors.primary900}>
                  Top Performer
                </H3>
                <TopPerformer user={user} title='Weekly by Volume' />
                <TopPerformer user={user} title='Monthly by Volume' />
                <TopPerformer user={user} title='Top sign ups' />
              </Box>
              <Box width='50%' p='0' bg='none' border='none' boxShadow='none'>
                <img
                  src={newStrategiesBanner}
                  alt='flipMeBanner'
                  style={{ width: '100%' }}
                />
              </Box>
            </Flexed>
            <Flexed gap='20px' rowSM>
              <Box width='50%'>
                <H3 mb='15' color={color.colors.primary900}>
                  Team Recruits
                </H3>
                <TopPerformer user={user} />
                <TopPerformer user={user} />
                <TopPerformer user={user} />
                <TopPerformer user={user} />
              </Box>
              <Box width='50%'>
                {/* <img src={newStrategiesBanner} alt='flipMeBanner' /> */}
              </Box>
            </Flexed>
            {/* <Mobile>
              <img
                src={guardianNodesBannerMobile}
                alt='flipMeMobile'
                onClick={() => history.push(AKASHA)}
              />
            </Mobile> */}
            {/* <Swiper
              spaceBetween={20}
              autoplay={{ delay: 5000 }}
              loop
              navigation={true}
              modules={[Navigation]}
              className='mySwiper'>
              <SwiperSlide>
                <Desktop>
                  <img
                    src={guardianNodesBanner}
                    alt='flipMeBanner'
                    onClick={() => history.push(AKASHA)}
                  />
                </Desktop>
                <Mobile>
                  <img
                    src={guardianNodesBannerMobile}
                    alt='flipMeMobile'
                    onClick={() => history.push(AKASHA)}
                  />
                </Mobile>
              </SwiperSlide>
              <SwiperSlide>
                <Desktop>
                  <img
                    src={dreamTripsBanner}
                    alt='flipMeBanner'
                    onClick={() => history.push(KRIPTO_TAP)}
                  />
                </Desktop>
                <Mobile>
                  <img
                    src={dreamTripsBannerMobile}
                    alt='flipMeMobile'
                    onClick={() => history.push(KRIPTO_TAP)}
                  />
                </Mobile>
              </SwiperSlide>
              <SwiperSlide>
                <Desktop>
                  <img
                    src={bitcoinBanner}
                    alt='flipMeBanner'
                    onClick={() => history.push(DEX_NET)}
                  />
                </Desktop>
                <Mobile>
                  <img
                    src={bitcoinBannerMobile}
                    alt='flipMeMobile'
                    onClick={() => history.push(DEX_NET)}
                  />
                </Mobile>
              </SwiperSlide>
            </Swiper> */}
          </SlideWrapper>
        </Flexed>
      </Flexed>
      {/* <div style={{ margin: '70px 0' }}> */}
      {/* <IconTitleStyled>{t('earnings.notifications')}</IconTitleStyled>

        

        {dashboardInfo?.packageRankUpgradeNotifications?.map(
          (notification: PackageRankUpgradeNotification, index: number) => {
            return <RankNotification notification={notification} key={index} />;
          }
        )} */}

      {/* <SubscriptionWarning />
        {canBuyAkashaPackages && renderAkasha()} */}

      {/* <Link to={EARN_BET}>
          <Desktop>
            <img
              src={earnBet}
              alt='earnBetBanner'
              style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
            />
          </Desktop>
          <Mobile>
            <img
              src={earnBetMobile}
              alt='earnBetMobile'
              style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
            />
          </Mobile>
        </Link> */}

      {/* {canBuyTravelPackages && (
          <Link to={TRAVEL_PACKAGES}>
            <Desktop>
              <img
                src={travelBanner}
                alt='airdropBanner'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Desktop>
            <Mobile>
              <img
                src={travelBannerMobile}
                alt='airdropBannerMobile'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Mobile>
          </Link>
        )} */}

      {/* <WillyMemeCoinsBanner /> */}

      {/* {!isCanadaRestrictedUser && canBuyBigWhale && (
          <Link to={BIG_WHALE}>
            <Desktop>
              <img
                src={bigWhaleBanner}
                alt='bigWhaleBanner'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Desktop>
            <Mobile>
              <img
                src={bigWhaleBannerMobile}
                alt='bigWhaleBannerMobile'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Mobile>
          </Link>
        )}

        {!isCanadaRestrictedUser && (
          <Link to={SETTINGS_VIRTUAL_OFFICE}>
            <Desktop>
              <img
                src={licencesPromo}
                alt='licencesPromo'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Desktop>
            <Mobile>
              <img
                src={licencesPromoMobile}
                alt='licencesPromoMobile'
                style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
              />
            </Mobile>
          </Link>
        )} */}

      {/* FAST START BONUS */}
      {/* {!isCanadaRestrictedUser && <MoneyBack />} */}

      {/* MY OVERVIEW */}
      {/* <EarningsComponent user={user} backOffice={dashboardInfo} /> */}
      {/* STATISTICAL DATA */}
      {/* <StatisticalComponent backOffice={dashboardInfo} /> */}
      {/* <UnilevelDashboard /> */}

      {/* <ExclusiveGaming /> */}
      {/* <Exclusive /> */}

      {/* <IconTitleStyled>{t('earnings.notifications')}</IconTitleStyled>

        

        {dashboardInfo?.packageRankUpgradeNotifications?.map(
          (notification: PackageRankUpgradeNotification, index: number) => {
            return <RankNotification notification={notification} key={index} />;
          }
        )} */}

      {/* <SubscriptionWarning />
        {canBuyAkashaPackages && renderAkasha()} */}
      {/* <StartYourJourneyNotification /> */}
      {/* <KycPackageNotifications /> */}
      {/* <SecurityNotification /> */}

      {/* <NumberOfMembers backOffice={dashboardInfo} count={joinedAfterCount} /> */}
      {/* </div> */}
      {/* {!isCanadaRestrictedUser && (
        <WelcomeSidebar open={welcome} setOpen={setWelcome} />
      )} */}
    </AnimatedDashboard>
  );
};

export default Dashboard;

const TopPerformer = ({ user, title }: { user: User; title?: string }) => {
  return (
    <Box border mb='8'>
      {title && (
        <>
          <H5 color={color.colors.primary900}>{title}</H5>
          <SectionSeparator margin='10px 0' />
        </>
      )}
      <Flexed gap='1s0px' center>
        <UserImageCircle
          image={user?.profileImageUrl}
          name={user?.name}
          surname={user?.surname}
          size='40px'
          fontSize='16px'
          margin={'0 8px 0 0'}
        />
        <Flexed center between width='100%'>
          <div>
            <H4>{user?.username}</H4>
            <P3>
              {user?.name} {user?.surname}
            </P3>
          </div>

          <Flexed center>
            <img src={mex} alt='mex' />
            <P2 ml='8'>23/08/2025</P2>
          </Flexed>
        </Flexed>
      </Flexed>
    </Box>
  );
};
